import { createFileRoute } from "@tanstack/react-router";

import { SessionsPanel } from "../../../workspaces/settings/SessionsPanel";

export const Route = createFileRoute("/_console/settings/sessions")({
  component: SessionsPanel,
});
